/* eslint-disable */

import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { utility } from "../../../utility/utilityProvider";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";

//to show item stored in array on collection
export const ArrayCell = (props) => {

  const field = props?.field || "";
  let value = [];
  let displayValue = "";

  if (field.includes(".")) {
    const keys = field.split(".");

    if (keys.length > 2 && keys.includes("[]")) {
      const parentArr = props.dataItem[keys[0]] || [];
      let allChild = [];

      parentArr.forEach(item => {
        if (Array.isArray(item[keys[2]])) {
          allChild.push(...item[keys[2]]);
        }
      });

      value = Array.from(
        new Set(allChild.map(obj => JSON.stringify(obj)))
      ).map(str => JSON.parse(str));

    } else {
      const fieldValue = props.dataItem?.[keys[0]]?.[keys[1]];
      value = Array.isArray(fieldValue) ? fieldValue : [];
    }

  } else {
    const fieldValue = props.dataItem?.[field];
    value = Array.isArray(fieldValue) ? fieldValue : [];
  }

  if (props?.format?.trim() === "length") {
    displayValue = value.length;
  }
  else if (!value.length) {
    displayValue = "";
  }
  else {
    displayValue = value.filter(v => v && v[props.format]).map(v => v[props.format]).join(", ");
  }

  return (
    <td
      colSpan={props.colSpan}
      role="gridcell"
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      {...useTableKeyboardNavigation(props.id)}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      style={props.style}
    >
      <div style={{ height: "12px" }}>
        <span
          title={props.tooltip}
          onClick={(e) => {
            e.stopPropagation();
            if (props.onClick) {
              props.onClick(props.dataItem);
            }
          }}
        >
          {displayValue ?? ""}
        </span>
      </div>
    </td>
  );
};
